import React from 'react';
import { 
  generalQuestions, 
  financeQuestions, 
  goalsQuestions, 
  familyQuestions, 
  healthQuestions, 
  securityQuestions, 
  analyticsQuestions 
} from '../data/faqData';

const FAQLoggedIn: React.FC = () => {
  return (
    <div style={{ color: '#1f2937' }}>
      <h2 style={{ 
        fontSize: '42px', 
        fontWeight: 'bold', 
        margin: '0 0 20px 0',
        color: '#667eea'
      }}>
        ❓ Часто задаваемые вопросы
      </h2>
      <p style={{ 
        fontSize: '18px', 
        color: '#6b7280',
        margin: '0 0 50px 0'
      }}>
        Всё, что нужно знать о возможностях AvatarMe
      </p>

      {/* Категории функционала */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
        {/* Общие вопросы */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>🌟 Общие вопросы</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {generalQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Финансы */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>💰 Финансы</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {financeQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Цели и задачи */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>🎯 Цели и задачи</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {goalsQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Семья */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>👨‍👩‍👧‍👦 Семья</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {familyQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Здоровье */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>🏥 Здоровье</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {healthQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Безопасность */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>🔒 Безопасность</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {securityQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Аналитика */}
        <section>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: 'bold', color: '#1f2937' }}>📊 Аналитика</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {analyticsQuestions.map((item, idx) => (
              <div
                key={idx}
                style={{
                  background: 'white',
                  padding: '20px 25px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}
              >
                <h4 style={{ fontSize: '18px', margin: '0 0 8px 0', fontWeight: 'bold', color: '#1f2937' }}>{item.q}</h4>
                <p style={{ fontSize: '15px', margin: 0, color: '#6b7280', lineHeight: '1.6' }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* CTA */}
      <div style={{
        marginTop: '60px',
        padding: '40px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '12px',
        textAlign: 'center',
        color: 'white'
      }}>
        <h3 style={{ fontSize: '28px', margin: '0 0 12px 0', fontWeight: 'bold' }}>
          Не нашли ответ на свой вопрос?
        </h3>
        <p style={{ fontSize: '16px', margin: '0 0 20px 0', opacity: 0.95 }}>
          Свяжитесь с нами в Telegram — мы всегда рады помочь!
        </p>
        <a
          href="https://t.me/FedorRubtsov"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'inline-block',
            padding: '14px 35px',
            background: 'white',
            border: 'none',
            borderRadius: '8px',
            color: '#667eea',
            fontSize: '16px',
            fontWeight: 'bold',
            textDecoration: 'none',
            boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
            transition: 'all 0.3s'
          }}
        >
          Написать в Telegram
        </a>
      </div>
    </div>
  );
};

export default FAQLoggedIn;
